import { Component } from '@angular/core';

@Component({
    selector: 'flyfreely-portal-ui-airspace-risk-sidebar',
    templateUrl: './airspace-risk-sidebar.component.html',
    styleUrls: ['./airspace-risk-sidebar.component.scss']
})
export class AirspaceRiskSidebarComponent {}
